export default function HealthCheck() {
    return (<div>
        Status: OK
    </div>)
}
